export default "__VITE_ASSET__fDmcEcOi__"